import { PayloadAction } from '@reduxjs/toolkit'

import { SortDirectionCapital } from '../../../types'
import { PlannedTradeColumnKey } from '../types'

import { TradingPlanState } from './initialState'

export const reducers = {
  updatePage: (state: TradingPlanState, action: PayloadAction<number>) => {
    state.pagination.page = action.payload
  },
  updatePageSize: (state: TradingPlanState, action: PayloadAction<number>) => {
    state.pagination.perPage = action.payload
  },
  updateOrderBy: (state: TradingPlanState, action: PayloadAction<PlannedTradeColumnKey>) => {
    state.pagination.page = 1
    state.pagination.order = SortDirectionCapital.asc
    state.pagination.orderBy = action.payload
  },
  updateSortOrder: (state: TradingPlanState, action: PayloadAction<SortDirectionCapital>) => {
    state.pagination.page = 1
    state.pagination.order = action.payload
  },
  resetReports: (state: TradingPlanState) => {
    state.reports = null
    state.reportsLoading = false
    state.reportsError = null
  },
}
